export const festivalInfo = {
  name: "입장거봉포도축제",
  fullName: "2026년 제27회 입장거봉포도축제",
  year: "2026",
  round: "제27회",
  dateText: "2026. 09. 20 (일) ~ 09. 21 (월)",
  dateShort: "09. 20 ~ 09. 21",
  dateBadge: "9월 20일 · 21일",
  timeText: "오전 10시 ~ 오후 6시",
  venue: "입장초등학교 운동장",
  address: "충남 천안시 서북구 입장면 하장4길 19",
  organizer: "입장거봉포도축제추진위원회",
  tel: "041-585-3992",
  mapQuery: "입장초등학교",
};

export const navItems = [
  { id: "about", label: "축제소개" },
  { id: "schedule", label: "축제일정" },
  { id: "programs", label: "프로그램" },
  { id: "lineup", label: "출연진" },
  { id: "gallery", label: "갤러리" },
  { id: "location", label: "오시는길" },
];

export const heroSlides = [
  {
    seq: "ipjang-hero-a",
    src: "https://readdy.ai/api/search-image?query=A%20lively%20Korean%20autumn%20grape%20festival%20opening%20ceremony%20with%20a%20decorated%20outdoor%20stage%20colorful%20bunting%20flags%20and%20a%20cheerful%20crowd%20of%20local%20families%20gathered%20in%20front%20purple%20and%20green%20festival%20banners%20green%20vine%20archway%20entrance%20warm%20golden%20afternoon%20sunlight%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1600&height=900&seq=ipjang-hero-a&orientation=landscape&nocache=true",
    alt: "깃발과 포도 아치가 장식된 축제 개막식 무대 전경",
  },
  {
    seq: "ipjang-hero-b",
    src: "https://readdy.ai/api/search-image?query=Wide%20view%20of%20a%20bustling%20local%20festival%20ground%20at%20a%20school%20playground%20filled%20with%20white%20market%20booths%20food%20stalls%20and%20visitors%20strolling%20around%20colorful%20tents%20purple%20grape%20themed%20decorations%20and%20green%20trees%20warm%20bright%20autumn%20daylight%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1600&height=900&seq=ipjang-hero-b&orientation=landscape&nocache=true",
    alt: "부스와 천막이 펼쳐진 축제 행사장 전경",
  },
  {
    seq: "ipjang-hero-c",
    src: "https://readdy.ai/api/search-image?query=Energetic%20singer%20performing%20on%20an%20outdoor%20festival%20stage%20at%20dusk%20with%20warm%20colorful%20stage%20lights%20a%20happy%20crowd%20watching%20and%20clapping%20purple%20and%20green%20festival%20banners%20hanging%20green%20grape%20leaf%20decorations%20soft%20evening%20glow%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1600&height=900&seq=ipjang-hero-c&orientation=landscape&nocache=true",
    alt: "저녁 무대에서 공연하는 가수와 환호하는 관객",
  },
];

export const heroEyebrows = [
  "거봉포도 수확체험",
  "품평회 · 시식회",
  "개막 축하공연",
  "거봉가요제",
];

export const aboutStats = [
  { value: "09. 20 ~ 21", unit: "", label: "2026년 9월, 이틀간" },
  { value: "27", unit: "회", label: "스물일곱 번째 이어온 축제" },
  { value: "무료 관람", unit: "", label: "누구나 부담 없이 즐기는 축제" },
];

export const aboutHighlights = [
  {
    no: "01",
    title: "천안 입장면의 대표 농산물",
    desc: "바닷바람과 일교차가 키워낸 진한 단맛의 거봉포도를 만나보세요.",
  },
  {
    no: "02",
    title: "품평회와 시식회",
    desc: "올해 가장 좋은 거봉을 뽑는 품평회와 갓 수확한 포도 시식이 함께합니다.",
  },
  {
    no: "03",
    title: "누구나 즐기는 체험",
    desc: "수확체험부터 어린이 체험존까지 온 가족이 함께 즐길 수 있습니다.",
  },
];

export const aboutImage = {
  src: "https://readdy.ai/api/search-image?query=Freshly%20harvested%20purple%20Geobong%20grape%20clusters%20resting%20in%20a%20rustic%20wooden%20basket%20with%20green%20vine%20leaves%20on%20a%20cream%20linen%20cloth%20soft%20natural%20window%20light%20editorial%20food%20photography%20rich%20purple%20and%20green%20tones%20clean%20minimal%20background%20high%20detail%20harmonious%20composition&width=1000&height=750&seq=ipjang-about&orientation=landscape",
  alt: "바구니에 담긴 갓 수확한 거봉포도",
};

export const scheduleDays = [
  {
    id: "day1",
    label: "DAY 1",
    date: "09. 20 (일)",
    theme: "개막 · 품평회 · 축하공연",
    events: [
      { time: "10:00", tag: "상설", title: "개장 및 농특산물 판매 시작", desc: "축제장 상설 판매존 · 먹거리존 운영 시작" },
      { time: "10:30", tag: "품평회", title: "제27회 입장거봉포도 품평회", desc: "입장면 농가가 출품한 거봉포도를 심사합니다" },
      { time: "11:30", tag: "시식회", title: "거봉포도 시식회", desc: "갓 수확한 거봉포도를 무료로 맛보세요" },
      { time: "13:00", tag: "체험", title: "거봉포도 수확체험 1회차", desc: "사전신청자를 대상으로 진행되는 수확체험" },
      { time: "14:00", tag: "체험", title: "어린이 포도알 찾기", desc: "어린이 체험존에서 즐기는 놀이 프로그램" },
      { time: "15:00", tag: "체험", title: "거봉포도 수확체험 2회차", desc: "내 손으로 직접 따는 거봉포도" },
      { time: "16:00", tag: "무대", title: "읍면동 노래자랑", desc: "주민과 함께하는 화합의 무대" },
      { time: "17:30", tag: "특집", title: "개막 축하공연", desc: "강진 · 강혜연 · 윤윤서 · 앵두걸스 · 려화 · 장미남" },
    ],
  },
  {
    id: "day2",
    label: "DAY 2",
    date: "09. 21 (월)",
    theme: "거봉가요제 · 주민 공연",
    events: [
      { time: "10:00", tag: "상설", title: "포도 판매 & 나눔 행사", desc: "산지 직거래 특별가 판매와 나눔 행사" },
      { time: "11:00", tag: "가요제", title: "거봉가요제 예선", desc: "노래 실력을 겨루는 예선 무대" },
      { time: "12:30", tag: "상설", title: "점심 시간 · 먹거리존 운영", desc: "축제장 먹거리존에서 여유롭게" },
      { time: "13:30", tag: "무대", title: "입장면 주민자치센터 공연", desc: "풍물놀이와 체조 공연" },
      { time: "15:00", tag: "가요제", title: "거봉가요제 본선", desc: "예선을 통과한 실력자들의 본선 무대" },
      { time: "16:30", tag: "무대", title: "댄스 & 통기타 공연", desc: "주민자치센터 회원들의 갈고닦은 실력" },
      { time: "17:30", tag: "특집", title: "시상식 & 폐막", desc: "거봉가요제 시상과 함께 축제를 마무리합니다" },
    ],
  },
];

export const scheduleAlways = [
  "거봉포도 판매장",
  "품평회 전시존",
  "농특산물 판매존",
  "푸드트럭 · 먹거리존",
  "어린이 체험존",
  "포토존",
];

export const programs = [
  {
    tag: "대표",
    name: "거봉포도 품평회",
    desc: "입장면 농가가 정성껏 키운 거봉포도 중 최고를 가리는 자리입니다.",
    src: "https://readdy.ai/api/search-image?query=A%20local%20grape%20judging%20event%20with%20farmers%20presenting%20large%20purple%20Geobong%20grape%20clusters%20on%20a%20wooden%20table%20while%20judges%20inspect%20and%20visitors%20gather%20around%20to%20watch%20green%20vine%20leaves%20and%20festival%20banners%20warm%20natural%20daylight%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-prog-judge&orientation=landscape&nocache=true",
    alt: "품평회에 전시된 거봉포도",
  },
  {
    tag: "대표",
    name: "포도 시식회",
    desc: "갓 수확한 거봉포도를 현장에서 바로 맛볼 수 있습니다.",
    src: "https://readdy.ai/api/search-image?query=Festival%20visitors%20happily%20tasting%20fresh%20purple%20grapes%20at%20a%20busy%20booth%20with%20small%20plates%20and%20green%20leaves%20wooden%20counter%20and%20cheerful%20crowd%20warm%20bright%20daylight%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-prog-taste&orientation=landscape&nocache=true",
    alt: "시식회에서 거봉포도를 맛보는 방문객",
  },
  {
    tag: "체험",
    name: "거봉포도 수확체험",
    desc: "포도밭에서 내 손으로 직접 거봉포도를 수확하는 인기 체험입니다.",
    src: "https://readdy.ai/api/search-image?query=A%20happy%20family%20with%20children%20harvesting%20ripe%20purple%20Geobong%20grapes%20together%20in%20a%20sunny%20vineyard%20rows%20of%20green%20vines%20and%20full%20grape%20clusters%20baskets%20overflowing%20with%20grapes%20warm%20cheerful%20natural%20light%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-prog-harvest&orientation=landscape&nocache=true",
    alt: "가족이 함께하는 거봉포도 수확체험",
  },
  {
    tag: "무대",
    name: "거봉가요제",
    desc: "입장면 주민과 방문객이 함께 노래 실력을 겨루는 축제의 밤입니다.",
    src: "https://readdy.ai/api/search-image?query=A%20song%20contest%20contestant%20singing%20on%20an%20outdoor%20festival%20stage%20with%20a%20microphone%20stand%20warm%20stage%20lights%20and%20an%20enthusiastic%20audience%20watching%20colorful%20festival%20lights%20purple%20and%20green%20decorations%20evening%20atmosphere%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-prog-song&orientation=landscape&nocache=true",
    alt: "저녁 무대에서 열리는 거봉가요제",
  },
  {
    tag: "장터",
    name: "농특산물 판매장",
    desc: "입장면에서 나는 거봉포도와 농특산물을 산지 직거래로 만나보세요.",
    src: "https://readdy.ai/api/search-image?query=A%20busy%20local%20farm%20produce%20market%20at%20a%20festival%20with%20vendors%20selling%20fresh%20purple%20grapes%20in%20wooden%20crates%20green%20vegetables%20and%20visitors%20browsing%20colorful%20stalls%20and%20hanging%20banners%20warm%20morning%20light%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-prog-market&orientation=landscape&nocache=true",
    alt: "거봉포도와 농특산물이 진열된 판매장",
  },
  {
    tag: "체험",
    name: "어린이 체험존",
    desc: "포도알 찾기와 만들기 체험으로 아이들이 신나게 뛰어놀 수 있는 공간입니다.",
    src: "https://readdy.ai/api/search-image?query=Happy%20children%20playing%20a%20fun%20grape%20themed%20game%20at%20an%20outdoor%20festival%20activity%20booth%20colorful%20props%20green%20vines%20and%20festival%20decorations%20with%20parents%20watching%20warm%20bright%20daylight%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-prog-kids&orientation=landscape&nocache=true",
    alt: "축제장에서 놀이를 즐기는 아이들",
  },
];

export const lineup = [
  {
    name: "강진",
    tag: "SPECIAL STAGE",
    desc: "9. 20 (일) 개막 축하공연",
    src: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20male%20Korean%20trot%20singer%20performing%20on%20an%20outdoor%20festival%20stage%20warm%20stage%20lights%20blurred%20audience%20background%20clean%20simple%20backdrop%20editorial%20photography%20purple%20and%20green%20tones%20high%20detail%20harmonious%20composition&width=600&height=600&seq=ipjang-line-a&orientation=squarish",
    alt: "개막 축하공연에 출연하는 가수 강진",
  },
  {
    name: "강혜연",
    tag: "SPECIAL STAGE",
    desc: "9. 20 (일) 개막 축하공연",
    src: "https://readdy.ai/api/search-image?query=Portrait%20of%20an%20elegant%20female%20Korean%20singer%20performing%20on%20an%20outdoor%20festival%20stage%20warm%20stage%20lights%20soft%20bokeh%20background%20clean%20simple%20backdrop%20editorial%20photography%20purple%20and%20green%20tones%20high%20detail%20harmonious%20composition&width=600&height=600&seq=ipjang-line-b&orientation=squarish",
    alt: "개막 축하공연에 출연하는 가수 강혜연",
  },
  {
    name: "앵두걸스",
    tag: "DANCE STAGE",
    desc: "9. 20 (일) 개막 축하공연",
    src: "https://public.readdy.ai/ai/img_res/edited_7c09f47bdbc7c64b4393da66f08c5b7f_d5d9178b.jpg",
    alt: "무대에 오르는 댄스팀 앵두걸스",
  },
  {
    name: "입장면 주민자치센터",
    tag: "LOCAL STAGE",
    desc: "9. 21 (월) 거봉가요제 · 풍물놀이",
    src: "https://public.readdy.ai/ai/img_res/edited_ef2bf7081e4098e2ef34d1d0a16e4d20_b3e824b1.jpg",
    alt: "풍물놀이 공연을 선보이는 주민자치센터 회원",
  },
];

export const extraArtists = ["윤윤서", "려화", "장미남"];

export const locationCards = [
  {
    tag: "주 행사장",
    name: "입장초등학교 운동장",
    address: "충남 천안시 서북구 입장면 하장4길 19",
    mapQuery: "입장초등학교 천안",
  },
  {
    tag: "문의",
    name: "입장거봉포도축제추진위원회",
    address: "입장면 행정복지센터 · 041-585-3992",
    mapQuery: "입장면 행정복지센터",
  },
];

export const transportInfo = [
  {
    icon: "ri-roadster-line",
    title: "자가용",
    desc: "내비게이션에서 '입장초등학교'를 검색해 주세요. 행사장 주변 임시 주차장을 이용하실 수 있습니다.",
  },
  {
    icon: "ri-bus-2-line",
    title: "대중교통",
    desc: "천안 시내버스 입장 방면 노선을 이용해 입장면 소재지에서 하차 후 도보로 이동하실 수 있습니다.",
  },
  {
    icon: "ri-parking-box-line",
    title: "주차 안내",
    desc: "축제 기간에는 행사장 인근에 임시 주차장이 운영됩니다. 안내 요원의 안내에 따라 주차해 주세요.",
  },
];

export const venueImage = {
  src: "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20neat%20outdoor%20festival%20ground%20with%20white%20tents%20arranged%20on%20green%20grass%20surrounded%20by%20trees%20bright%20autumn%20daylight%20clean%20simple%20background%20editorial%20photography%20purple%20and%20green%20tones%20high%20detail%20harmonious%20composition&width=1200&height=800&seq=ipjang-venue&orientation=landscape",
  alt: "천막과 부스가 배치된 축제 행사장 배치 전경",
};

export const applyInfo = {
  programName: "거봉포도 수확체험",
  rounds: ["10:30", "13:00", "15:00", "16:30"],
  capacity: "회차당 30팀 내외",
  feeNote: "체험 재료비는 현장 안내에 따릅니다.",
  image: {
    src: "https://readdy.ai/api/search-image?query=Hands%20of%20a%20visitor%20gently%20cutting%20a%20ripe%20purple%20grape%20cluster%20from%20the%20vine%20in%20a%20sunny%20vineyard%20with%20green%20leaves%20and%20dappled%20light%20warm%20cheerful%20editorial%20photography%20purple%20and%20green%20tones%20clean%20simple%20background%20high%20detail%20harmonious%20composition&width=1100&height=780&seq=ipjang-apply&orientation=landscape",
    alt: "포도송이를 수확하는 손",
  },
};

export const applySteps = [
  { no: "01", title: "신청서 작성", desc: "방문 일자와 회차, 인원을 선택해 신청서를 작성합니다." },
  { no: "02", title: "신청 완료 안내", desc: "신청 접수 후 안내에 따라 현장에서 확인합니다." },
  { no: "03", title: "현장 수령", desc: "체험 당일 안내 데스크에서 이름을 확인하고 체험에 참여합니다." },
];

export const galleryImages = [
  {
    title: "개막 축하공연",
    category: "무대",
    src: "https://readdy.ai/api/search-image?query=A%20colorful%20opening%20ceremony%20performance%20on%20an%20outdoor%20festival%20stage%20with%20singers%20and%20dancers%20confetti%20and%20a%20large%20crowd%20of%20local%20families%20watching%20purple%20and%20green%20stage%20decorations%20and%20bunting%20flags%20warm%20afternoon%20sunlight%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-01&orientation=landscape",
    alt: "개막 축하공연이 펼쳐지는 축제 무대",
  },
  {
    title: "거봉포도 품평회",
    category: "품평회",
    src: "https://readdy.ai/api/search-image?query=Farmers%20and%20judges%20gathered%20around%20a%20wooden%20display%20table%20covered%20with%20large%20purple%20Geobong%20grape%20clusters%20during%20a%20grape%20judging%20contest%20at%20a%20local%20festival%20green%20vine%20leaves%20and%20numbered%20tags%20warm%20daylight%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-02&orientation=landscape",
    alt: "거봉포도를 심사하는 품평회 현장",
  },
  {
    title: "거봉포도 수확체험",
    category: "체험",
    src: "https://readdy.ai/api/search-image?query=A%20family%20with%20young%20children%20picking%20ripe%20purple%20grapes%20from%20green%20vines%20in%20a%20sunny%20vineyard%20carrying%20a%20wicker%20basket%20full%20of%20fresh%20grape%20clusters%20warm%20cheerful%20sunlight%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-03&orientation=landscape",
    alt: "가족이 함께하는 거봉포도 수확체험",
  },
  {
    title: "먹거리존",
    category: "장터",
    src: "https://readdy.ai/api/search-image?query=Busy%20food%20stall%20area%20at%20a%20Korean%20local%20festival%20with%20steaming%20snacks%20vendors%20serving%20customers%20and%20colorful%20awnings%20people%20enjoying%20street%20food%20under%20warm%20afternoon%20light%20purple%20and%20green%20festival%20decorations%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-04&orientation=landscape",
    alt: "다양한 먹거리가 가득한 축제 먹거리존",
  },
  {
    title: "거봉포도 시식회",
    category: "시식회",
    src: "https://readdy.ai/api/search-image?query=Festival%20visitors%20sampling%20freshly%20cut%20purple%20grapes%20at%20a%20tasting%20booth%20small%20ceramic%20plates%20and%20green%20leaves%20on%20a%20wooden%20counter%20with%20a%20friendly%20crowd%20gathered%20around%20warm%20bright%20daylight%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-05&orientation=landscape",
    alt: "갓 수확한 거봉포도를 맛보는 시식회",
  },
  {
    title: "거봉가요제 본선",
    category: "가요제",
    src: "https://readdy.ai/api/search-image?query=A%20singer%20performing%20with%20emotion%20during%20a%20song%20contest%20final%20round%20on%20an%20outdoor%20stage%20warm%20stage%20lights%20and%20a%20large%20attentive%20audience%20purple%20and%20green%20festival%20banners%20and%20lights%20evening%20atmosphere%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-06&orientation=landscape",
    alt: "관객 앞에서 노래하는 거봉가요제 본선 무대",
  },
  {
    title: "어린이 체험존",
    category: "체험",
    src: "https://readdy.ai/api/search-image?query=Children%20laughing%20and%20playing%20a%20grape%20themed%20game%20at%20an%20outdoor%20activity%20booth%20with%20colorful%20props%20green%20vines%20and%20festival%20decorations%20parents%20cheering%20nearby%20warm%20bright%20daylight%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-07&orientation=landscape",
    alt: "놀이를 즐기는 어린이 체험존",
  },
  {
    title: "농특산물 판매장",
    category: "장터",
    src: "https://readdy.ai/api/search-image?query=A%20lively%20farm%20produce%20market%20at%20a%20festival%20with%20wooden%20crates%20stacked%20with%20fresh%20purple%20grapes%20green%20vegetables%20and%20local%20goods%20vendors%20and%20visitors%20bargaining%20under%20hanging%20banners%20warm%20morning%20sunlight%20candid%20documentary%20style%20festival%20photograph%20high%20detail%20realistic%20atmosphere&width=800&height=600&seq=ipjang-gallery-08&orientation=landscape",
    alt: "거봉포도와 농특산물이 진열된 판매장",
  },
];

export const songInfo = {
  name: "거봉가요제",
  dateText: "2026. 09. 21 (월)",
  prelimTime: "예선 11:00",
  finalTime: "본선 15:00",
  venue: "입장초등학교 운동장 메인무대",
  deadline: "2026. 09. 15 (화)까지",
  capacity: "선착순 30팀 내외",
  fee: "참가비 무료",
  prize: "대상 · 최우수상 · 우수상 · 인기상",
  image: {
    src: "https://readdy.ai/api/search-image?query=A%20singer%20holding%20a%20microphone%20performing%20confidently%20on%20an%20outdoor%20festival%20stage%20with%20warm%20colorful%20stage%20lights%20and%20a%20cheering%20crowd%20purple%20and%20green%20festival%20decorations%20and%20banners%20evening%20atmosphere%20candid%20documentary%20style%20photograph%20realistic%20festival%20atmosphere%20high%20detail&width=1100&height=780&seq=ipjang-song&orientation=landscape",
    alt: "무대에서 노래를 부르는 거봉가요제 참가자",
  },
};

export const songSteps = [
  { no: "01", title: "참가 신청", desc: "아래 신청서를 작성해 거봉가요제 참가를 신청합니다." },
  { no: "02", title: "예선 무대", desc: "축제 당일 예선 무대에서 준비한 노래를 선보입니다." },
  { no: "03", title: "본선 · 시상", desc: "예선 통과자는 본선에서 경연하고 시상이 진행됩니다." },
];

export const songGuideRows = [
  { label: "개최 일시", value: "2026. 09. 21 (월)" },
  { label: "경연 일정", value: "예선 11:00 / 본선 15:00" },
  { label: "무대 장소", value: "입장초등학교 운동장 메인무대" },
  { label: "참가 대상", value: "노래를 사랑하는 누구나 (개인·단체 무관)" },
  { label: "신청 마감", value: "2026. 09. 15 (화)까지" },
  { label: "참가 정원", value: "선착순 30팀 내외" },
  { label: "참가 비용", value: "참가비 무료" },
  { label: "시상 내역", value: "대상 · 최우수상 · 우수상 · 인기상" },
];